<template>
   <div class="error">
    <div class="">
   <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.2" d="M32.6923 17C32.6923 20.1036 31.772 23.1376 30.0477 25.7182C28.3234 28.2987 25.8726 30.3101 23.0052 31.4978C20.1378 32.6855 16.9826 32.9963 13.9386 32.3908C10.8946 31.7853 8.09848 30.2907 5.90387 28.0961C3.70926 25.9015 2.21471 23.1054 1.60922 20.0614C1.00373 17.0174 1.31449 13.8622 2.5022 10.9948C3.68992 8.1274 5.70124 5.6766 8.28183 3.95231C10.8624 2.22802 13.8964 1.30768 17 1.30768C21.1619 1.30768 25.1533 2.96097 28.0961 5.90385C31.039 8.84673 32.6923 12.8381 32.6923 17Z" fill="var(--bad)"/>
<path d="M17 0C13.6377 0 10.3509 0.997032 7.55531 2.86502C4.75968 4.733 2.58074 7.38804 1.29406 10.4944C0.00736584 13.6007 -0.329291 17.0189 0.326658 20.3165C0.982607 23.6142 2.6017 26.6433 4.97919 29.0208C7.35668 31.3983 10.3858 33.0174 13.6835 33.6733C16.9811 34.3293 20.3993 33.9926 23.5056 32.7059C26.612 31.4193 29.267 29.2403 31.135 26.4447C33.003 23.6491 34 20.3623 34 17C33.9952 12.4928 32.2026 8.17153 29.0156 4.98444C25.8285 1.79735 21.5072 0.0047597 17 0ZM17 31.3846C14.155 31.3846 11.3739 30.541 9.00834 28.9604C6.6428 27.3798 4.79909 25.1332 3.71035 22.5048C2.62162 19.8763 2.33675 16.984 2.89179 14.1937C3.44682 11.4034 4.81682 8.84026 6.82855 6.82854C8.84027 4.81682 11.4034 3.44681 14.1937 2.89178C16.984 2.33675 19.8763 2.62161 22.5048 3.71035C25.1332 4.79908 27.3798 6.6428 28.9604 9.00833C30.541 11.3739 31.3846 14.155 31.3846 17C31.3803 20.8137 29.8634 24.47 27.1667 27.1667C24.47 29.8634 20.8137 31.3803 17 31.3846ZM24.8462 22.2308C24.8462 22.5776 24.7084 22.9102 24.4631 23.1554C24.2179 23.4007 23.8853 23.5385 23.5385 23.5385H10.4615C10.1147 23.5385 9.78211 23.4007 9.53687 23.1554C9.29163 22.9102 9.15385 22.5776 9.15385 22.2308C9.15385 21.8839 9.29163 21.5513 9.53687 21.3061C9.78211 21.0608 10.1147 20.9231 10.4615 20.9231H23.5385C23.8853 20.9231 24.2179 21.0608 24.4631 21.3061C24.7084 21.5513 24.8462 21.8839 24.8462 22.2308ZM9.15385 13.7308C9.15385 13.3428 9.26889 12.9636 9.48443 12.641C9.69997 12.3184 10.0063 12.067 10.3647 11.9185C10.7232 11.7701 11.1176 11.7312 11.4981 11.8069C11.8786 11.8826 12.2281 12.0694 12.5024 12.3437C12.7767 12.6181 12.9636 12.9676 13.0392 13.3481C13.1149 13.7286 13.0761 14.123 12.9276 14.4814C12.7792 14.8398 12.5277 15.1462 12.2052 15.3617C11.8826 15.5773 11.5033 15.6923 11.1154 15.6923C10.5952 15.6923 10.0962 15.4856 9.72837 15.1178C9.36051 14.7499 9.15385 14.251 9.15385 13.7308ZM24.8462 13.7308C24.8462 14.1187 24.7311 14.498 24.5156 14.8205C24.3 15.1431 23.9937 15.3945 23.6353 15.543C23.2768 15.6915 22.8824 15.7303 22.5019 15.6546C22.1214 15.5789 21.7719 15.3921 21.4976 15.1178C21.2233 14.8435 21.0365 14.4939 20.9608 14.1134C20.8851 13.7329 20.9239 13.3385 21.0724 12.9801C21.2209 12.6217 21.4723 12.3153 21.7948 12.0998C22.1174 11.8843 22.4967 11.7692 22.8846 11.7692C23.4049 11.7692 23.9038 11.9759 24.2716 12.3437C24.6395 12.7116 24.8462 13.2105 24.8462 13.7308Z" fill="var(--bad)"/>
</svg>
</div>

      <p><slot></slot></p> 
    </div>   
</template>
<script>
export default {
    data: function () {return {}},
    props:{
        time: String,
    },
    methods: {
        rand(){return (Math.random() * (5 - 1) + 1) + 's';},
    },
}
</script>
<style scoped>
    @keyframes animation {
        0% { opacity: 1;}
        50%{ opacity: 0;}
        100%{opacity: 1;}
    }
    .blink{
        animation-name: animation;
        animation-duration: 4s;
        animation-iteration-count: infinite;
    }
    .error{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .error p{
    color: var(--g5);
    color: var(--bad);
    font-size: 13px;
    line-height: 140%;
    margin: 6px 0 0;
    letter-spacing: 0.01em;
    
  }
</style>